module.exports = __webpack_public_path__ + "img/Flag_of_Gibraltar.0ad62abd.svg";